import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  set_popoverCloser5swh04w6mwwp as set_popoverCloser,
  get_popoverCloser4tnhy9srbgxw as get_popoverCloser,
  get_popoverParent2ywfrf2fh1f87 as get_popoverParent,
} from './ViewContextExtensions.mjs';
import { KMutableProperty11e8g1gb0ecb9j as KMutableProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  _get_pageNavigator_$ref_twffzs1xctzo7bzxnjn as _get_pageNavigator_$ref_twffzs,
  _set_pageNavigator_$ref_jevpp01vlvro7b3g4ux as _set_pageNavigator_$ref_jevpp0,
} from '../navigation/deprecated.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var launch;
var reactiveScope;
var navigator$delegate;
function closePopovers(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  var tmp0_safe_receiver = get_popoverCloser_0(_this__u8e3s4);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver();
  set_popoverCloser_0(_this__u8e3s4, null);
  var tmp1_safe_receiver = get_popoverParent_0(_this__u8e3s4);
  if (tmp1_safe_receiver == null)
    null;
  else {
    closePopovers(tmp1_safe_receiver);
  }
}
function set_popoverCloser_0(_this__u8e3s4, value) {
  _init_properties_deprecated_kt__373bhv();
  set_popoverCloser(_this__u8e3s4.get_context_h02k06_k$(), value);
}
function get_popoverCloser_0(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  return get_popoverCloser(_this__u8e3s4.get_context_h02k06_k$());
}
function get_popoverParent_0(_this__u8e3s4) {
  _init_properties_deprecated_kt__373bhv();
  return get_popoverParent(_this__u8e3s4.get_context_h02k06_k$());
}
var properties_initialized_deprecated_kt_8461sb;
function _init_properties_deprecated_kt__373bhv() {
  if (!properties_initialized_deprecated_kt_8461sb) {
    properties_initialized_deprecated_kt_8461sb = true;
    launch = Unit_instance;
    reactiveScope = Unit_instance;
    var tmp = KMutableProperty1();
    var tmp_0 = _get_pageNavigator_$ref_twffzs();
    navigator$delegate = getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0());
  }
}
//region block: exports
export {
  closePopovers as closePopovers1732azyb7hmuq,
};
//endregion

//# sourceMappingURL=deprecated.mjs.map
